import { combineReducers } from 'redux';

import userReducer from './userReducer';
import sidebarReducer from './sidebarReducer';
import comboReducer from './comboReducer';
import globalReducer from './globalReducer';
import homeReducer from './homeReducer';
import loginReducer from './loginReducer';
import databaseReducer from './databaseReducer';
import dataPrioritasReducer from './dataPrioritasReducer';
import datasetReducer from './datasetReducer';
import dataNonPrioritasReducer from './dataNonPrioritasReducer';
import uploadDownloadReducer from './uploadDownloadReducer';
import organisasiReducer from './organisasiReducer';
import datasetCategoryReducer from './master/datasetCategoryReducer';
import infografisReducer from './master/infografisReducer';
import beritaReducer from './master/beritaReducer';
import kritikSaranReducer from './master/kritikSaranReducer';
import indicatorReducer from './master/indicatorReducer';
import galeriReducer from './master/galeriReducer';

import ubahProfileReducer from './master/ubahProfileReducer';
import ubahPasswordReducer from './master/ubahPasswordReducer';

import konfigurasiAplikasiReducer from './pengaturan/konfigurasiAplikasiReducer';
import menuReducer from './pengaturan/menuReducer';
import bannerReducer from './pengaturan/bannerReducer';
import iklanReducer from './pengaturan/iklanReducer';
import tvReducer from './tvReducer';

import sipdWalidataReducer from './external/sipdWalidataReducer';

const reducer = combineReducers({
    sidebarReducer,
    userReducer,
    comboReducer,
    globalReducer,
    homeReducer,
    loginReducer,
    databaseReducer,
    dataPrioritasReducer,
    datasetReducer,
    dataNonPrioritasReducer,
    uploadDownloadReducer,
    organisasiReducer,
    datasetCategoryReducer,
    infografisReducer,
    beritaReducer,
    kritikSaranReducer,
    indicatorReducer,
    galeriReducer,

    ubahProfileReducer,
    ubahPasswordReducer,
    konfigurasiAplikasiReducer,
    menuReducer,
    bannerReducer,
    iklanReducer,
    tvReducer,
    sipdWalidataReducer
});

export default reducer;